import { useState } from 'react';
import { initialValues, SearchFormValues } from '../schema';
import { useReportContext } from '../context';

export const useDialogState = () => {
  const [initialSearchDialogOpen, setInitialSearchDialogOpen] = useState(true);
  const [editPrintTemplateDialogOpen, setEditPrintTemplateDialogOpen] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [searchParams, setSearchParams] = useState<SearchFormValues>(initialValues);
  const { setQueryParams, exportToExcel } = useReportContext();

  const handleInitialSearch = async (
    formData: SearchFormValues,
    getReport: (params: MuaHangRecord) => Promise<void>
  ) => {
    const apiParams = { ...formData, group_by: formData.group_by === '0' ? '' : formData.group_by };
    try {
      await getReport(apiParams);
      setSearchParams(formData);
      setQueryParams(apiParams);
      setInitialSearchDialogOpen(false);
      setShowTable(true);
      handleInitialSearchClose();
    } catch (e) {
      return;
    }
  };

  const handleRefreshClick = async (getReport: (params: MuaHangRecord) => Promise<void>) => {
    if (searchParams) {
      await getReport({ ...searchParams, group_by: searchParams.group_by === '0' ? null : searchParams.group_by });
    }
  };

  const handleInitialSearchClose = () => {
    setInitialSearchDialogOpen(false);
  };

  const handleSearchClick = () => {
    setInitialSearchDialogOpen(true);
  };

  const handleEditPrintTemplateClick = () => {
    setEditPrintTemplateDialogOpen(true);
  };

  const handleClosePrintTemplateDialog = () => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleSavePrintTemplate = (_template: MuaHangRecord) => {
    setEditPrintTemplateDialogOpen(false);
  };

  const handleRowClick = (_row: MuaHangRecord) => {};

  const handleFixedColumnsClick = () => {};

  const handleExportDataClick = () => exportToExcel();

  return {
    // State
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,

    // Handlers
    handleInitialSearch,
    handleRefreshClick,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleRowClick,
    handleFixedColumnsClick,
    handleExportDataClick
  };
};
